"use strict";

import Page from "./SignupFromInvitation.jsx";

export const auth = false;
export const title = "i18n:signupFromInvitation.pageTitle";
export const Component = Page;
